import { render, staticRenderFns } from "./EvaluationGravityForm.vue?vue&type=template&id=ca5642b0&"
import script from "./EvaluationGravityForm.vue?vue&type=script&lang=js&"
export * from "./EvaluationGravityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports